export const GET_UDDYAMAAN_PROGRAMS_REQUEST = 'GET_UDDYAMAAN_PROGRAMS_REQUEST';
export const GET_UDDYAMAAN_PROGRAMS_SUCCESS = 'GET_UDDYAMAAN_PROGRAMS_SUCCESS';
export const GET_UDDYAMAAN_PROGRAMS_FAILURE = 'GET_UDDYAMAAN_PROGRAMS_FAILURE';
